/* SUNBORN VARIANT OVERFLOW — 9/25
   Liquid's product.variants is hard-capped at 250, so the picker JSON that
   assets/plugins.js (Swatchoption) matches against silently drops every
   variant past #250 on large products (e.g. a 7x11x4 = 308-variant set).
   Those combos then resolve to "Unavailable".

   This file is ONLY loaded (snippets/product-variant-picker.liquid) on
   products where product.variants_count > product.variants.size, so it
   has zero effect anywhere else. plugins.js is NOT modified.

   How it works:
   1. On load, fetches ALL of the product's variants from the Storefront
      API (tokenless, same-origin /api/<ver>/graphql.json -- confirmed
      working on this store 9/25), paginated 250 at a time.
   2. Converts the missing ones into the exact shape plugins.js expects
      (same keys as {{ product.variants | json }}) and pushes them into the
      picker's own cached variantData array. From then on plugins.js
      matches, prices, swaps images and enables Add to Cart natively.
   3. Images: each overflow variant borrows featured_image/featured_media
      from an embedded variant with the same image file (so gallery
      jumping works). If none matches, both stay null -- plugins.js's
      updateImage() already no-ops on a null featured_image.
   4. If the shopper picks an overflow combo BEFORE the prefetch lands,
      the button shows "Loading..." (still disabled -- nothing can be added
      by mistake) and the selection is re-run automatically once data
      arrives. If the fetch fails, the native "Unavailable" state is
      restored -- i.e. worst case = exactly the pre-9/25 behavior.
   Prices/availability come live from Shopify every page load, so nothing
   goes stale (unlike the sunborn.variant_overflow metafield fallback in
   snippets/sunborn-variant-json.liquid, which this supersedes). */
(function () {
  if (window.__sbVariantOverflow) return;
  window.__sbVariantOverflow = true;

  var API = '/api/2025-07/graphql.json';
  var QUERY =
    'query($h:String!,$c:String){product(handle:$h){variants(first:250,after:$c){' +
    'pageInfo{hasNextPage endCursor}nodes{id title availableForSale sku requiresShipping ' +
    'price{amount} compareAtPrice{amount} selectedOptions{name value} image{url}}}}}';

  function fileKey(url) {
    if (!url) return '';
    return String(url).split('?')[0].split('/').pop().toLowerCase();
  }

  function toCents(money) {
    return money && money.amount != null ? Math.round(parseFloat(money.amount) * 100) : null;
  }

  function fetchAllVariants(handle) {
    var all = [];
    function page(cursor) {
      return fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ query: QUERY, variables: { h: handle, c: cursor || null } })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (j) {
          var v = j && j.data && j.data.product && j.data.product.variants;
          if (!v) throw new Error('No variant data returned');
          all = all.concat(v.nodes || []);
          return v.pageInfo && v.pageInfo.hasNextPage ? page(v.pageInfo.endCursor) : all;
        });
    }
    return page(null);
  }

  function setButtonText(el, text) {
    var form = document.getElementById('product-form-' + el.dataset.section);
    var span = form && form.querySelector('[name="add"] > span');
    if (span) span.textContent = text;
  }

  function enhance(el) {
    if (el.__sbOverflowInit) return;
    el.__sbOverflowInit = true;

    var total = parseInt(el.getAttribute('data-sb-variant-count'), 10);
    var handle = el.getAttribute('data-sb-handle');
    if (!total || !handle || typeof el.stSwatchDate !== 'function') return;

    var data;
    try {
      data = el.stSwatchDate();
    } catch (e) {
      return;
    }
    if (!Array.isArray(data) || data.length >= total) return; // nothing missing

    var state = { loaded: false, failed: false, pending: false, touched: false };

    // Runs AFTER plugins.js's own change handler (registered earlier, in
    // the element constructor), so el.swatch already reflects this pick.
    el.addEventListener('change', function () {
      state.touched = true;
      if (el.swatch || state.loaded || state.failed) return;
      state.pending = true;
      setButtonText(el, 'Loading…');
    });

    var have = {};
    var images = {};
    data.forEach(function (v) {
      have[v.id] = true;
      if (v.featured_image && v.featured_image.src && v.featured_media) {
        var k = fileKey(v.featured_image.src);
        if (k && !images[k]) images[k] = { fi: v.featured_image, fm: v.featured_media };
      }
    });
    var tmpl = data[0] || {};

    fetchAllVariants(handle)
      .then(function (nodes) {
        var added = 0;
        nodes.forEach(function (n) {
          var id = parseInt(String(n.id).split('/').pop(), 10);
          if (!id || have[id]) return;
          var opts = (n.selectedOptions || []).map(function (o) { return o.value; });
          var title = opts.join(' / ');
          var img = n.image ? images[fileKey(n.image.url)] : null;
          data.push({
            id: id,
            title: title,
            option1: opts[0] != null ? opts[0] : null,
            option2: opts[1] != null ? opts[1] : null,
            option3: opts[2] != null ? opts[2] : null,
            sku: n.sku || null,
            requires_shipping: n.requiresShipping !== false,
            taxable: tmpl.taxable != null ? tmpl.taxable : true,
            featured_image: img ? img.fi : null,
            available: !!n.availableForSale,
            name: (tmpl.name ? String(tmpl.name).split(' - ')[0] : '') + ' - ' + title,
            public_title: title,
            options: opts,
            price: toCents(n.price),
            weight: tmpl.weight || 0,
            compare_at_price: toCents(n.compareAtPrice),
            inventory_management: tmpl.inventory_management || 'shopify',
            barcode: null,
            featured_media: img ? img.fm : null,
            requires_selling_plan: false,
            selling_plan_allocations: [],
            quantity_rule: tmpl.quantity_rule || { min: 1, max: null, increment: 1 }
          });
          have[id] = true;
          added++;
        });
        state.loaded = true;
        if (!added) return;
        if (state.pending && !el.swatch) {
          state.pending = false;
          el.swatchUpdate(); // re-run the shopper's pending pick natively
        } else if (state.touched && typeof el.updateSwatchStatuses === 'function') {
          el.updateSwatchStatuses(); // refresh greyed-out states with full data
        }
      })
      .catch(function (err) {
        state.failed = true;
        console.warn('SunBorn variant overflow: lookup failed, native behavior kept.', err);
        if (state.pending) {
          state.pending = false;
          el.swatchUpdate(); // restores the native "Unavailable" state
        }
      });
  }

  function init() {
    document
      .querySelectorAll('pr-option[data-sb-variant-count], selects-box[data-sb-variant-count]')
      .forEach(enhance);
  }

  var ready = [];
  if (window.customElements && customElements.whenDefined) {
    ready.push(customElements.whenDefined('pr-option').catch(function () {}));
  }
  Promise.all(ready).then(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });
})();
